import React from "react";
import { useQuery } from "@apollo/client";
import { Devices, hash } from "../gql/DevicesQuery";
import { DevicesSubscription, hash as hash2 } from "../gql/DevicesSubscription";
import ListGroup from "react-bootstrap/ListGroup";

const AvailableDevices = ({ setSelected, current }) => {
  const { data, loading, error, subscribeToMore } = useQuery(Devices, {
    fetchPolicy: "network-only",
    context: { headers: { "X-Trust-Key": hash } },
  });

  subscribeToMore({
    document: DevicesSubscription,
    updateQuery: (prev) => {
      return prev;
    },
    context: { headers: { "X-Trust-Key": hash2 } },
  });

  if (loading) return;

  if (error) return;

  if (data) {
    return (
      <div
        style={{
          width: "300px",
          border: "1px solid grey",
          borderRadius: "8px",
        }}
      >
        <ListGroup style={{ maxHeight: "300px", overflowY: "auto" }}>
          {data.allDevices.nodes
            .filter((el) => {
              if (current.length > 0) {
                return current.every((f) => {
                  return f.deviceByDeviceId.deviceName !== el.deviceName;
                });
              }

              return el;
            })
            .map((devices) => (
              <ListGroup.Item
                action
                eventKey={devices.id}
                variant="info"
                onClick={() => setSelected(devices.id)}
              >
                {devices.deviceName}
              </ListGroup.Item>
            ))}
        </ListGroup>
      </div>
    );
  }
};

export default AvailableDevices;
